'use strict';

angular.module('membership')
  .controller('DocumentsCtrl', [
    '$scope', 'documentsViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.company);
    }
  ]);
